import { SVGProps } from 'react';

const CheckmarkScaleExtraSmallKindSingleAppearanceFilledEnclosedTrue = (props: SVGProps<SVGSVGElement>) => (
    <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#clip0_597_14)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6ZM8.60349 4.14645C8.79875 4.34172 8.79875 4.6583 8.60349 4.85356L5.60349 7.85356C5.40823 8.04882 5.09165 8.04882 4.89639 7.85356L3.39639 6.35356C3.20112 6.1583 3.20112 5.84172 3.39639 5.64645C3.59165 5.45119 3.90823 5.45119 4.10349 5.64645L5.24994 6.7929L7.89639 4.14645C8.09165 3.95119 8.40823 3.95119 8.60349 4.14645Z"
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
        </g>
        <defs>
            <clipPath id="clip0_597_14">
                <rect width={12} height={12} fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export default CheckmarkScaleExtraSmallKindSingleAppearanceFilledEnclosedTrue;
